.centred {
  display: grid;
  place-items: center;
  min-height: 320px;
  padding: 32px 0;
}

.errorPage {
  min-height: 100dvh;
  padding: 24px;
  background:
    radial-gradient(circle at 85% 15%, var(--co-magenta-subtle), transparent 32rem),
    var(--co-canvas-subtle);
}

.brand {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  color: var(--co-text);
}

.brandLogo {
  width: 30px;
  height: 30px;
}

.brand span {
  display: flex;
  flex-direction: column;
  line-height: var(--co-leading-extra-tight);
}

.brand strong {
  font-size: var(--co-size-caption);
}

.brand small {
  color: var(--co-text-additional);
  font-size: var(--co-size-badge);
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.fullPageContent {
  display: grid;
  place-items: center;
  min-height: calc(100dvh - 78px);
}

.errorCard {
  width: min(100%, 680px);
  padding: 32px;
  color: var(--co-text);
  background: var(--co-surface);
  border: 1px solid var(--co-ui-faint);
  border-radius: 16px;
  box-shadow: var(--co-shadow-raised);
}

.errorIcon {
  display: grid;
  place-items: center;
  width: 52px;
  height: 52px;
  margin-bottom: 20px;
  color: var(--co-danger-text);
  background: var(--co-danger-subtle);
  border-radius: 50%;
}

.errorCopy {
  max-width: 580px;
}

.eyebrow {
  margin: 0 0 6px;
  color: var(--co-danger-text);
  font-size: var(--co-size-small);
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.heading {
  margin: 0;
  color: var(--co-text);
  font-size: var(--co-size-headline-3);
  line-height: var(--co-leading-tight);
}

.description {
  margin: 10px 0 0;
  color: var(--co-text-additional);
  font-size: var(--co-size-body);
  line-height: var(--co-leading-loose);
}

.actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
  margin-top: 24px;
}

.overviewLink {
  min-height: 24px;
  color: var(--co-magenta);
  font-size: var(--co-size-caption);
  font-weight: 700;
  text-underline-offset: 3px;
}

.overviewLink:hover {
  color: var(--co-magenta-hover);
}

.overviewLink:focus-visible,
.details summary:focus-visible {
  outline: none;
  border-radius: var(--co-radius-s);
  box-shadow: var(--co-focus-ring);
}

.details {
  padding-top: 20px;
  margin-top: 24px;
  border-top: 1px solid var(--co-ui-faint);
  color: var(--co-text-additional);
  font-size: var(--co-size-caption);
}

.details summary {
  width: fit-content;
  cursor: pointer;
  color: var(--co-text);
  font-weight: 700;
}

.details dl {
  display: grid;
  gap: 12px;
  margin: 16px 0 0;
}

.details dl div {
  display: grid;
  grid-template-columns: minmax(112px, 0.25fr) 1fr;
  gap: 16px;
}

.details dt {
  font-weight: 700;
}

.details dd {
  min-width: 0;
  margin: 0;
  overflow-wrap: anywhere;
  color: var(--co-text);
}

.details code {
  font-family: var(--co-mono);
  font-size: var(--co-size-small);
}

@media (max-width: 600px) {
  .centred {
    min-height: 240px;
    padding: 12px 0;
  }

  .errorPage {
    padding: 18px 12px;
  }

  .fullPageContent {
    min-height: calc(100dvh - 66px);
  }

  .errorCard {
    padding: 24px 20px;
    border-radius: 12px;
  }

  .actions {
    align-items: stretch;
    flex-direction: column;
  }

  .overviewLink {
    align-self: flex-start;
  }

  .details dl div {
    grid-template-columns: 1fr;
    gap: 4px;
  }
}
